import AppService from '@/services/ReimburseService.js'
const namespaced = true
const state = {
    lists: {},
    total_count: '',
    count: 1,
    list: {},
    code: '',
    filter_list: {},
    filter_name: '',
    is_no_records: '',
    detail_list: {},
    updated_id: '',
    message: {},
    delete: {},
    filter_hdr: {},
    log_details: '',
    field: {
        gl_acc_type_id: '8',
        gl_acc_name: '',
        is_sub_account: '0',
        gl_parent_acc_id: '',
        gl_acc_desc: '',
        acc_code:''
    },
    export: {},
    status_code: '',
    status_message: '',
    status_type: ''


}
const mutations = {
    SET_DATAS(state, lists) {
        state.lists = lists.accounts_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
        state.is_no_records = lists.is_no_records

    },
    LIST_DATA(state, list) {
        state.list = list,
            state.error = ''
    },
    LIST_DETAILS(state, data) {

        state.detail_list = data.data

    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    TAG_LIST(state, data) {
        state.expensetaglist = data

    },
    DELETE_RESULT(state, delete_result) {
        state.delete = delete_result
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },


}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom

    }) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.getAccounts(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchaccountsexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom

    }) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.getAccountsExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    statuschange({
        commit,
        rootState
    }, data) {

        return AppService.accounts.postAccountsstatus(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchAccountDetails({
        commit,
        rootState
    }) {
        return AppService.accounts.getAccountDetails(rootState.session.token)
            .then(response => {
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.accounts.postAccountdelete(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    singledelete({
        commit,
        rootState
    }, id) {

        return AppService.accounts.postAccountSingleDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status)
                    commit('DELETE_RESULT', response.data.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, data) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.postAccount(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, list) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.postFiltercreateAccount(list, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.accounts.postFilterudpateAccount(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchfilterList({
        commit,
        rootState
    }, id) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.getAccountFilter(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.postFilterdeleteAccount(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.accounts.postAccountUpdate(field, id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, id) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.getAccount(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_DATA', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchAccountList({
        commit,
        rootState
    }, id) {
        //  appservice file comes form appservice.js (where we can called all the axios function)
        // axios is imported in appservice.js and we can use that in all the files (by call ing the function)
        return AppService.accounts.getAccount(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_DATA', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

}
export default {
    namespaced,
    state,
    mutations,
    actions
}